import * as React from "react";
import { SessionManager, SipClientContext } from "@dvrt/web-phone-client";
import { SessionStarter } from "../session/Container";
import { useChatConnector, useNewSipClient, useStopOnPageUnload } from "./hooks";
import { FormattedMessage } from "react-intl";
import { Center, Connecting } from "../widgets";

const SipClientContainer = ({ children }: { children: React.ReactNode }) => {
    const { client, identifier } = useNewSipClient();

    useStopOnPageUnload(client);

    return (
        <SipClientContext.Provider value={client}>
            <SessionManager>
                <SessionStarter client={client} identifier={identifier}>
                    {children}
                </SessionStarter>
            </SessionManager>
        </SipClientContext.Provider>
    );
};

export default function ClientContainer({ children }: { children: React.ReactNode }) {
    const connectionState = useChatConnector();

    if (connectionState === "connecting") return <Connecting />;

    if (connectionState === "error")
        return (
            <Center>
                <FormattedMessage id="meetingPage.room.connectionError" defaultMessage="Connection error..." />
            </Center>
        );

    return <SipClientContainer>{children}</SipClientContainer>;
}
